import { apiSlice } from '../../api';
import {
  GetBlockchainFeeMarkupsResult,
  GetBlockchainFeeMarkupsDTO,
  GetBlockchainFeeMarkupResult,
  GetBlockchainFeeMarkupByIdDTO,
  PostBlockchainFeeMarkupResult,
  PostBlockchainFeeMarkupDTO,
  PutBlockchainFeeMarkupResult,
  PutBlockchainFeeMarkupByIdDTO,
  DeleteBlockchainFeeMarkupResult,
  DeleteBlockchainFeeMarkupDTO,
} from './types';

const blockchainFeeMarkupsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBlockchainFeeMarkups: build.query<GetBlockchainFeeMarkupsResult, GetBlockchainFeeMarkupsDTO>(
      {
        query: () => ({
          url: '/admin/v1/blockchain-fee-markups',
          method: 'GET',
        }),
        providesTags: ['Fees'],
      }
    ),

    getBlockchainFeeMarkupById: build.query<
      GetBlockchainFeeMarkupResult,
      GetBlockchainFeeMarkupByIdDTO
    >({
      query: ({ blockchain_fee_markup_id }) => ({
        url: `/admin/v1/blockchain-fee-markups/${blockchain_fee_markup_id}`,
        method: 'GET',
      }),
      providesTags: ['Fees'],
    }),
    postBlockchainFeeMarkup: build.mutation<
      PostBlockchainFeeMarkupResult,
      PostBlockchainFeeMarkupDTO
    >({
      query: (body) => ({
        url: '/admin/v1/blockchain-fee-markups',
        method: 'POST',
        body,
      }),
    }),
    putBlockchainFeeMarkup: build.mutation<
      PutBlockchainFeeMarkupResult,
      PutBlockchainFeeMarkupByIdDTO
    >({
      query: ({ body, blockchain_fee_markup_id }) => ({
        url: `/admin/v1/blockchain-fee-markups/${blockchain_fee_markup_id}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteBlockchainFeeMarkup: build.mutation<
      DeleteBlockchainFeeMarkupResult,
      DeleteBlockchainFeeMarkupDTO
    >({
      query: ({ blockchain_fee_markup_id }) => ({
        url: `/admin/v1/blockchain-fee-markups/${blockchain_fee_markup_id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useDeleteBlockchainFeeMarkupMutation,
  useGetBlockchainFeeMarkupByIdQuery,
  useGetBlockchainFeeMarkupsQuery,
  useLazyGetBlockchainFeeMarkupByIdQuery,
  useLazyGetBlockchainFeeMarkupsQuery,
  usePostBlockchainFeeMarkupMutation,
  usePutBlockchainFeeMarkupMutation,
} = blockchainFeeMarkupsEndpoints;

export type BlockchainFeeMarkupsController = typeof blockchainFeeMarkupsEndpoints;
